import PanelSet from '@molecules/panelset/panelset.mjs';
import * as storelocator from '@molecules/store-locator/store-locator.mjs';

(function ($, Drupal, drupalSettings, once) {

  'use strict';

  const container = document.querySelector('.js-topnavstorelocator');

  // Exit on pages where the container does not exist.
  if (!container) return;

  const togglerForm = container.querySelector('.js-topnavstorelocator-toggler-hide');
  const popupWrapper = container.querySelector('.js-topnavstorelocator-popup');

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Globally accessible API
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Promutuel.topnavStoreLocator = {
    // Constants
    PANEL_FORM_POSTAL    : 'FORM_POSTAL',
    PANEL_FORM_DETAILS   : 'FORM_DETAILS',
    PANEL_RESULT_FOUND   : 'RESULT_FOUND',
    PANEL_RESULT_NOTFOUND: 'RESULT_NOTFOUND',
    PANEL_ERROR          : 'ERROR',

    SEARCHMODE_MANUAL    : 'manual',
    SEARCHMODE_POSTAL    : 'postal',
    SEARCHMODE_GEO       : 'geo',
    SEARCHMODE_CLIENTINFO: 'details',

    // Properties
    searchmode: 'manual',
    mutualId  : undefined,
    panels    : new PanelSet(),

    // Methods

    show: async function() {
      // Re-populate details panel (if a mutual is defined) every time the popup is open.
      if (this.mutualId !== undefined) {
        this.populateMutualInfo(await Promutuel.mutuals.getMutualDetails(this.mutualId));
        this.panels.goTo(this.PANEL_RESULT_FOUND);
      }

      togglerForm.removeAttribute('hidden');
      popupWrapper.removeAttribute('hidden');
      setTimeout(_ => { popupWrapper.classList.add('topnavstorelocator__popup--open'); }, 1); // Timeout to allow transition trigger.
    },
    hide: function() {
      if (!popupWrapper.classList.contains('topnavstorelocator__popup--open')) return;

      popupWrapper.classList.remove('topnavstorelocator__popup--open');
      togglerForm.hidden = true;
      Promutuel.mutuals.personalizeUI();
    },

    emptyForms: function() {
      // Empty forms.
      document.querySelector(".js-slocpc-form").reset();
      document.querySelector(".js-slocpi-form").reset();
    },

    populateMutualInfo: function(data) {
      if (!data.mutual) return;
      // Memorize the current mutual ID.
      this.mutualId = data.mutual;

      // Populate main panel
      Promutuel.storeLocation?.populateCard(container.querySelector('.js-topnavstorelocator-found'), {
        overtitle    : data.overtitle,
        title        : data.title,
        url          : data.url,
        toll_free    : data.head_office?.toll_free,
        phone        : data.head_office?.phone,
        fax          : data.head_office?.fax,
        email        : data.head_office?.email,
        hours        : data.head_office?.hours,
        hours_comment: data.head_office?.hours_comment,
        address      : [
          data.head_office?.address.line1,
          data.head_office?.address.line2,
          data.head_office?.address.line3,
        ]
      });
    },
  };

  const PTSL = Promutuel.topnavStoreLocator;
  PTSL.panels
    .withPanel(PTSL.PANEL_FORM_POSTAL,     container.querySelector('.js-slocpanel-postalcode'))
    .withPanel(PTSL.PANEL_FORM_DETAILS,    container.querySelector('.js-slocpanel-personalinfo'))
    .withPanel(PTSL.PANEL_RESULT_FOUND,    container.querySelector('.js-topnavstorelocator-found'))
    .withPanel(PTSL.PANEL_RESULT_NOTFOUND, container.querySelector('.js-topnavstorelocator-notfound'))
    .withPanel(PTSL.PANEL_ERROR, container.querySelector('.js-topnavstorelocator-error'))
    .goTo(PTSL.PANEL_FORM_POSTAL);

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Behaviors and event management
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Drupal.behaviors.promutuel_topnavStoreLocator = {
    attach: function attach(context) {

      $(once('promutuelTopnavStoreLocator', '.js-topnavstorelocator', context)).each(function() {
        // ---------------------------------------------------------------------
        // Open / close the whole popup
        container.querySelector('.js-topnavstorelocator-toggler-show').addEventListener('click', event => {
          PTSL.show();
          event.preventDefault();
          event.stopPropagation();
        });

        // Close the popup if the user clicks anywhere outside it.
        document.body.addEventListener('mousedown', event => {
          if (popupWrapper.contains(event.target)) return false;
          if (pca?.container?.contains(event.target)) return false;
          if (event.target?.classList.contains('pcaitem')) return false;

          PTSL.hide();
          PTSL.emptyForms();
        });

        container.querySelectorAll('.js-slocpanel-hide').forEach(element => {
          element.addEventListener('click', event => {
            PTSL.hide();
            PTSL.emptyForms();
          });
        });

        // ---------------------------------------------------------------------
        // Navigation between panels

        container.querySelector('.js-slocpanel-postalcode-toggle').addEventListener('click', event => {
          event.preventDefault();
          PTSL.panels.goTo(PTSL.PANEL_FORM_POSTAL);
        });
        container.querySelector('.js-slocpanel-personalinfo-toggle').addEventListener('click', event => {
          event.preventDefault();
          PTSL.panels.goTo(PTSL.PANEL_FORM_DETAILS);
        });
        container.querySelectorAll('.js-topnavstorelocator-back').forEach(node => {
          node.addEventListener('click', event => {
            event.preventDefault();
            PTSL.panels.goBack();
            PTSL.emptyForms();
          });
        });
        container.querySelectorAll('.js-topnavstorelocator-see-all').forEach(node => {
          node.addEventListener('click', event => {
            event.preventDefault();
            window.location.href = drupalSettings.path.contactUsUrl;
          });
        });

        // ---------------------------------------------------------------------
        // Form handlers

        const onMutualFound = function(data, searchmode) {
          PTSL.populateMutualInfo(data);
          PTSL.panels.goTo(PTSL.PANEL_RESULT_FOUND);
          Promutuel.mutuals.setMyMutual({ id: data.mutual, searchmode });
        };

        const onMutualNotFound = function (err) {
          console.log(err);
          if(err.name === 'Http404NotFoundError') {
            PTSL.panels.goTo(PTSL.PANEL_RESULT_NOTFOUND);
          } else {
            PTSL.panels.goTo(PTSL.PANEL_ERROR);
          }
        };

        storelocator.initPostalCodeForm(container, {
          onsuccess: onMutualFound,
          onfailure: onMutualNotFound,
        });

        storelocator.initPersonalInfoForm(container, {
          idPrefix: 'topnavstorelocator',
          addressCompleteKey: drupalSettings.addresscomplete_key,
          onsuccess: onMutualFound,
          onfailure: onMutualNotFound,
          buttonText: Drupal.t('Click here if your address does not appear'),
        });

        // ---------------------------------------------------------------------
        // Find another mutual
        {
          const button = container.querySelector('.js-topnavstorelocator-restart');

          button.addEventListener('click', async event => {
            event.preventDefault();

            PTSL.panels.goTo(PTSL.PANEL_FORM_POSTAL);
          });
        }
      });
    }
  };
})(jQuery, Drupal, drupalSettings, once);
